<template>
    <md-icon class="md-icon-image" v-once>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
            <title>edit-item</title>
            <g>
                <path fill="#343A40" d="M279.07,147.91l85,85L179.48,417.53l-75.8,8.37a15.94,15.94,0,0,1-17.59-17.6l8.44-75.85Zm137.6-12.65L376.75,95.34a31.9,31.9,0,0,0-45.1,0L294.1,132.89l85,85,37.55-37.56A31.89,31.89,0,0,0,416.67,135.26Z"/>
            </g>
        </svg>
    </md-icon>
</template>

<script>
    import MdIcon from "../../../components/MdIcon/MdIcon";

    export default {
        name: 'GdEditItemIcon',
        components: {
            MdIcon
        }
    }
</script>
